import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';

export type Alarm = {
  description: string;
  color: string;
  iconClass: string;
  indicationId: number;
  date: string;
};

export type OccurredAlarm = {
  occurrence: number;
  description: string;
  level: 'EMERGENCY' | 'WARNING' | string;
  color: string;
  iconClass: string;
  indicationId: number | null;
};
export type AlarmEntityOverviewDetails = {
  latestAlarms: Alarm[];
  mostOccurredWeekly: OccurredAlarm[];
  mostOccurredMonthly: OccurredAlarm[];
};

export type AlarmState = {
  alarmEntityOverviewDetails: AlarmEntityOverviewDetails;
  loading: boolean;
  errorMessage: string;
};

export const initialState: AlarmState = {
  alarmEntityOverviewDetails: {
    latestAlarms: [],
    mostOccurredWeekly: [],
    mostOccurredMonthly: [],
  },
  loading: false,
  errorMessage: '',
};

export const alarmEntityOverviewDetailsSlice = createSlice({
  name: 'alarmEntityOverviewDetails',
  initialState,
  reducers: {
    getAlarmsForEntityOverviewSuccess(
      state,
      action: PayloadAction<AlarmEntityOverviewDetails>,
    ) {
      state.alarmEntityOverviewDetails = action.payload;
      state.loading = false;
    },
    clearAlarmEntityOverviewDetails: (state) => {
      state.alarmEntityOverviewDetails = {
        latestAlarms: [],
        mostOccurredWeekly: [],
        mostOccurredMonthly: [],
      };
      state.loading = false;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setErrorMessage: (state, action: PayloadAction<string>) => {
      state.errorMessage = action.payload;
      state.loading = false;
    },
  },
});

export const getAlarmsForEntityOverview = createAction<{
  entityId: string;
  toDate: string;
}>('GET_ALARMS_FOR_ENTITY_OVERVIEW_REQUEST');

export const {
  getAlarmsForEntityOverviewSuccess,
  setErrorMessage,
  setLoading,
  clearAlarmEntityOverviewDetails,
} = alarmEntityOverviewDetailsSlice.actions;

export const alarmEntityOverviewDetailsSelectors = {
  selectAlarmEntityOverviewDetails: (state: RootState) =>
    state.alarmEntityOverviewDetails.alarmEntityOverviewDetails,
};

export default alarmEntityOverviewDetailsSlice.reducer;
